import { render, staticRenderFns } from "./app-permissions-list.vue?vue&type=template&id=33d3caee&scoped=true&"
import script from "./app-permissions-list.vue?vue&type=script&lang=js&"
export * from "./app-permissions-list.vue?vue&type=script&lang=js&"
import style0 from "./app-permissions-list.vue?vue&type=style&index=0&id=33d3caee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3caee",
  null
  
)

export default component.exports